import { render, staticRenderFns } from "./DeviceEdit.vue?vue&type=template&id=0f0487d7&scoped=true&"
import script from "./DeviceEdit.vue?vue&type=script&lang=js&"
export * from "./DeviceEdit.vue?vue&type=script&lang=js&"
import style0 from "./DeviceEdit.vue?vue&type=style&index=0&id=0f0487d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0487d7",
  null
  
)

export default component.exports